import styles from 'styled-components';

const StyledHeading = styles.h6``;

const Heading6 = ({ children, ...rest }) => (
  <StyledHeading {...rest}>{children}</StyledHeading>
);

export default Heading6;
